const layoutClassNameMap = {
  'single': 'kye-data-statistic-wrap-single',
  'flat': 'kye-data-statistic-wrap-flat',
}
export function getLayoutModelClassName (model) {
  return layoutClassNameMap[model]
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/utils/wrap-tools.js